import { Controller } from '@hotwired/stimulus'
export default class extends Controller {

  static targets = ['form', 'modal']

  connect() {
    this.modal = new window.bootstrap.Modal(this.modalTarget)
  }

  openConfirmation(event) {
    event.preventDefault()
    this.modal.show()
  }

  submitForm() {
    this.modal.hide()
    this.formTarget.requestSubmit()
  }
}
